export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Скатерть размером 145 х 145 см из плотной непромокаемой ткани, которая называется Оксфорд. На ощупь гладкая и блестящая. Края скатерти аккуратно подшиты. Запечатать вы можете всю поверхность скатерти с лицевой стороны и картинка будет яркой даже спустя множество стирок.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>
          Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.
        </p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
